<template>
<div class="responsive_tabs_agileits"> 
	<h3 class="wthree_text_info dir">نظرات</h3>
	<div class="single_page_agile_its_w3ls">
		<div class="bootstrap-tab-text-grid">
            <div class="list" v-if="count!=0">
                <div class="card mb-3" v-for="item in list" :key="item.id">
                    <span class="position-absolute top-0 end-100 translate-middle badge rounded-pill" style="transform: translate(-110%, -33%) !important;" :class="{'bg-info': item.state == 1, 'bg-success': item.state == 2, 'bg-danger': item.state == 3}">{{ item.state == 1 ? 'در حال بررسی' : item.state == 2 ? 'تایید شده' : 'رد شده' }}</span>
                    <div class="card-body align-self-center d-flex flex-column flex-start justify-content-between w-100">
                        <div class="d-flex justify-content-between">
                            <p class="mb-0" style="font-weight: bold;">{{ item.user }}</p>
                            <span class="px-1" style="font-family: IranSans; background-color: rgb(249, 246, 242);">{{ convertToPersian(item.star) }}<i class="fa fa-star" style="color: rgb(231, 231, 50); padding-right: 0.2em;"></i></span>
                        </div>
                        <p class="mb-0" v-if="item.vote != '-'">{{ item.vote }}</p>
                        <p v-if="item.site_ans" ><span style="color: rgb(255, 0, 166);">پاسخ راداَپ :  </span>{{ item.site_ans }}</p>
                        <p v-if="item.supplier_ans"><span style="color: rgb(255, 0, 166);">پاسخ فروشگاه : </span>{{ item.supplier_ans }}</p>
                        <p class="mb-0 text-muted text-small">{{ item.time }}</p>
                    </div>
                    <div class="w-100">
                    <button class="btn btn-light m-1 p-1 position-relative text-dark" disabled style="font-size: 12px;" v-for="product in item.basket" >
                        <span class="position-absolute top-0 translate-middle badge rounded-pill  text-dark" style="left:15px;transform: translate(-110%, -33%) !important;font-weight: 700;" v-if="product.count > 1" >{{convertToPersian(String(product.count)) }}</span>
                        {{ product.name }}
                    </button>
                    </div>
                </div>
            </div>
			<div v-else>هنوز برای این محصول نظری ثبت نشده است.</div>
		</div>
	</div>
</div>

</template>

<script setup>
import { ref,defineProps } from '@vue/reactivity'
import { convertToPersian } from '@/composables/digits'
import axios from 'axios'

let props = defineProps(['stuff_id']);
let list = ref()
let avg = ref(0)
let count = ref()
function getList(){
    axios
    .get('https://radap.ir/Backend/api/section/survay/list.php?stuff_id='+props.stuff_id)
    .then(res=>{
        list.value = res.data.list
        count.value = res.data.count
		getAvg(list.value)
    })
}
getList()
function getAvg(list){
	for (let i = 0; i < list.length; i++) {
		avg.value += parseInt(list[i].star)
	}
	avg.value /= list.length
}
function PersianNumber(t){for(t=t.toString();t.search("0")>-1;)t=t.replace("0","۰");for(;t.search("1")>-1;)t=t.replace("1","۱");for(;t.search("2")>-1;)t=t.replace("2","۲");for(;t.search("3")>-1;)t=t.replace("3","۳");for(;t.search("4")>-1;)t=t.replace("4","۴");for(;t.search("5")>-1;)t=t.replace("5","۵");for(;t.search("6")>-1;)t=t.replace("6","۶");for(;t.search("7")>-1;)t=t.replace("7","۷");for(;t.search("8")>-1;)t=t.replace("8","۸");for(;t.search("9")>-1;)t=t.replace("9","۹");return t}

</script>

<style scoped>
.dcVdUe {
    width: 100%;
    max-width: 960px;
    margin: 20px auto;
}
.bztXvJ {
    position: relative;
    width: 100%;
}
.lcHuNb {
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
}
.idMpUg {
    display: flex;
    flex-direction: column;
}
.dZNIAH {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    justify-content: space-between;
}
.fnIfiZ {
    font-size: 22px;
    font-family: 'Sahel';
    font-weight: 700;
    line-height: 30px;
    letter-spacing: -0.04ch;
    text-transform: none;
    color: rgb(25, 25, 25);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}
.dsHpAb {
    right: 0px;
    position: absolute;
}
.dZNIAH > * + * {
    margin-left: 16px !important;
}
.bVqFxV {
    position: relative;
    max-width: 100%;
    margin: 0px;
    display: inline-flex;
    min-height: 32px;
    border-radius: 100%;
    border: none;
    cursor: pointer;
    transition: background-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
    user-select: none;
    text-decoration: none;
    text-align: center;
    background-color: rgb(231, 231, 231);
    box-shadow: rgb(231 231 231) 0px 0px 0px 1px inset;
    color: rgb(25, 25, 25);
    height: 32px;
    width: 32px;
    padding: 0px;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
}
.jFpckg {
    flex-shrink: 0;
}
.fNxhMJ {
    max-width: 100%;
}
.gJoNDK {
    max-width: 100%;
}
<style>
.fNxhMJ > * + * {
    margin-top: 16px !important;
}
.eDoSbG {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.enKZat {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.hsAHxt {
    font-size: 18px;
    font-family: 'Sahel';
    font-weight: 700;
    line-height: 24px;
    letter-spacing: -0.04ch;
    text-transform: none;
    color: rgb(25, 25, 25);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}
.FbIzD {
    transform: scale(1.5);
    transform-origin: center center;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    flex-direction: column;
}
.eDoSbG > * + * {
    margin-left: 12px !important;
}
.enKZat {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.cwMzOx {
    font-size: 14px;
    font-family: 'Sahel';
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0ch;
    text-transform: none;
    color: rgb(73, 73, 73);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}
.FbIzD {
    transform: scale(1.5);
    transform-origin: center center;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    flex-direction: column;
}
.enKZat > * + * {
    margin-left: 4px !important;
}
.enKZat > * + * {
    margin-left: 4px !important;
}
.cwMzOx {
    font-size: 14px;
    font-family: 'Sahel';
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0ch;
    text-transform: none;
    color: rgb(73, 73, 73);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}
.dOuBYZ {
    position: relative;
}
.hlcfoc {
    width: 100%;
    padding: 16px 0px 0px;
}
.jiSGsb {
    text-align: left;
    border: none;
    width: 100%;
    display: flex;
    vertical-align: middle;
    margin-right: 16px;
    border-radius: 8px;
}
.fWLLAh {
    background: none;
    color: inherit;
    font: inherit;
    cursor: pointer;
    height: 154px;
    min-width: 212px;
    max-width: 212px;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid rgb(227, 216, 216);
    display: inline-block;
    align-self: center;
    text-align: left;
    vertical-align: middle;
    margin: 0px;
}
.gJoNDK {
    max-width: 100%;
}
.gJoNDG {
    max-width: 100%;
}
.fpnchd {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.gJoNDQ {
    max-width: 100%;
}
.fpnchd {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.jdPVjd {
    font-size: 16px;
    font-family: 'Sahel';
    font-weight: 700;
    line-height: 22px;
    letter-spacing: -0.04ch;
    text-transform: none;
    color: rgb(25, 25, 25);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}
.ckgqVJ {
    display: flex;
    flex-wrap: wrap;
    -webkit-box-align: center;
    align-items: center;
    gap: 4px;
	justify-content: space-between;
}
.gJoNDG > * + * {
    margin-top: 8px !important;
}
.embond {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.cbFhUJ {
    font-size: 14px;
    font-family: 'Sahel';
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0ch;
    text-transform: none;
    color: rgb(118, 118, 118);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}
.enKZat {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}

.hlExXV {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
.cbFhUJ {
    font-size: 14px;
    font-family: 'Sahel';
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0ch;
    text-transform: none;
    color: rgb(118, 118, 118);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}

.eqicQd {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    margin-top: 2px !important;
}
.gJoNDK > * + * {
    margin-top: 4px !important;
}
.lcTVNM {
    font-size: 16px;
    font-family: 'Sahel';
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0ch;
    text-transform: none;
    color: rgb(25, 25, 25);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
    height: 70px;
    text-align: right;
}
.ggXGbS {
    display: contents;
}

.eJRtEB {
    max-width: 100%;
    display: flex;
    -webkit-box-align: stretch;
    align-items: stretch;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.gJoNDK > * + * {
    margin-top: 4px !important;
}
.fmJXop {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.hEGpgc {
    font-size: 14px;
    font-family: 'Sahel';
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0ch;
    text-transform: none;
    color: rgb(118, 118, 118);
    text-align: left;
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}

</style>